import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logodark from "../assets/logo_dark.png";
import logolight from "../assets/logo_light.PNG";
import { useAuth } from "../context/AuthContext";
import MobileMenu from "./MobileMenu";
import BurgerMenuButton from "./BurgerMenuButton"; // 👈 Reusable animated button

const Header = ({ scrollTo, activeNav, theme, toggleTheme }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const navActive = "border-b-2 border-orange-500 font-semibold text-orange-500";

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleNavClick = (id) => {
    navigate("/");
    setTimeout(() => scrollTo(id), 100);
    setMenuOpen(false);
  };

  return (
    <header className={`w-full px-4 py-3 ${theme === "dark" ? "bg-[#0c131d]" : "bg-white shadow"} flex justify-between items-center sticky top-0 z-50 transition duration-300`}>
      {/* Logo + Selector */}
      <div className="flex items-center gap-3 cursor-pointer" onClick={() => handleNavClick("hero")}>
        <img src={theme === "dark" ? logodark : logolight} alt="TwoFleet Logo" className="h-14 w-auto" />
        <select className="text-black text-sm px-2 py-1 rounded" aria-label="Product Selector">
          <option>OBD Tracker</option>
          <option>Fleet AI</option>
        </select>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center gap-6 text-sm">
        {["hero", "features", "pricing", "faq", "contact"].map((id) => (
          <button key={id} onClick={() => handleNavClick(id)} className={`hover:text-orange-500 transition ${activeNav === id ? navActive : ""}`}>
            {id === "hero" ? "Home" : id.charAt(0).toUpperCase() + id.slice(1)}
          </button>
        ))}

        {user ? (
          <>
            <Link to="/dashboard/vehicles" className="text-sm text-orange-500 hover:underline">Dashboard</Link>
            <span className="text-sm text-gray-600 dark:text-gray-300">Hello, {user.firstName || user.email}</span>
            <button onClick={handleLogout} className="bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded transition duration-300">
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/auth/signin" className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-1 rounded transition duration-300">Sign In</Link>
            <Link to="/auth/signup" className="border px-4 py-1 rounded hover:bg-gray-200 transition duration-300">Sign Up</Link>
          </>
        )}

        <button onClick={toggleTheme} className="ml-2 text-xl hover:scale-110 transition duration-300" aria-label="Toggle Theme">
          {theme === "dark" ? "☀️" : "🌙"}
        </button>
      </nav>

      {/* Mobile Toggle: Theme + Burger */}
      <div className="md:hidden flex items-center gap-2">
        <button onClick={toggleTheme} className="text-xl hover:scale-110 transition duration-300" aria-label="Toggle Theme">
          {theme === "dark" ? "☀️" : "🌙"}
        </button>
        <BurgerMenuButton isOpen={menuOpen} toggle={() => setMenuOpen(!menuOpen)} />
      </div>

      {/* Mobile Slide-in Menu */}
      {menuOpen && (
        <MobileMenu scrollTo={scrollTo} setMenuOpen={setMenuOpen} />
      )}
    </header>
  );
};

export default Header;
